import React from "react";
import "./NavigationIndicators.css";

const NavigationIndicators = ({
  items = [],
  currentIndex = 0,
  onIndicatorClick,
  isScrolling = false,
  className = "",
  ariaLabel = "Navigation indicators",
  showCount = false, // Optional: show count like "3 / 10"
  ...props
}) => {
  // Don't render if no items or only one item
  if (!items || items.length <= 1) {
    return null;
  }

  const handleClick = (index, e) => {
    e.preventDefault();
    e.stopPropagation();

    // Don't allow clicks while scrolling/transitioning
    if (isScrolling || !onIndicatorClick) {
      return;
    }

    onIndicatorClick(index);
  };

  return (
    <div
      className={`navigation-indicators ${className}`}
      role="tablist"
      aria-label={ariaLabel}
      {...props}
    >
      {/* Optional count display */}
      {showCount && (
        <span className="indicators-count" aria-hidden="true">
          {currentIndex + 1} / {items.length}
        </span>
      )}

      {/* Indicator buttons */}
      <div className="indicators-list">
        {items.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`indicator ${index === currentIndex ? "active" : ""} ${
              isScrolling ? "disabled" : ""
            }`}
            onClick={(e) => handleClick(index, e)}
            disabled={isScrolling}
            role="tab"
            aria-selected={index === currentIndex}
            aria-label={`Go to item ${index + 1} of ${items.length}`}
            tabIndex={index === currentIndex ? 0 : -1}
          />
        ))}
      </div>
    </div>
  );
};

export default NavigationIndicators;
